import React from "react";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

import { cn, Icon } from "@flare/ui";

import type { DeprecatedColorKeys } from "@/styles/deprecated-colors";
import { deprecatedColors } from "@/styles/deprecated-colors";

const Title = ({ children, isOpen }: React.PropsWithChildren<TitleProps>) => (
  <CollapsiblePrimitive.Trigger asChild>
    <button className="flex items-start justify-between w-full">
      {children}
      <div className="ml-8 flex shrink-0 items-center justify-center">
        {isOpen ? (
          <Icon name="minus" size="lg" color="action" />
        ) : (
          <Icon name="plus" size="lg" color="action" />
        )}
      </div>
    </button>
  </CollapsiblePrimitive.Trigger>
);

export interface FaqProps {
  borderColor?: DeprecatedColorKeys;
  iconColor?: DeprecatedColorKeys;
  isOpen: boolean;
  onItemClicked?: ({ isOpen }: { isOpen: boolean }) => void;
  question: React.ReactNode | string;
}

export interface TitleProps {
  isOpen: boolean;
}

export const Faq = ({
  children,
  question,
  onItemClicked = () => null,
  borderColor = "primary",
  isOpen,
}: React.PropsWithChildren<FaqProps>) => {
  const toggle = () => {
    onItemClicked({
      isOpen: !isOpen,
    });
  };

  return (
    <CollapsiblePrimitive.Root
      className={cn("border-t py-[40px] last:border-b")}
      style={{
        borderColor: deprecatedColors[borderColor],
      }}
      open={isOpen}
      onOpenChange={toggle}
    >
      <Title isOpen={isOpen}>{question}</Title>
      <CollapsiblePrimitive.Content
        className={cn(
          "overflow-hidden w-full max-w-[1100px] transition-all data-[state=closed]:animate-faq-close data-[state=open]:animate-faq-open",
        )}
      >
        {children}
      </CollapsiblePrimitive.Content>
    </CollapsiblePrimitive.Root>
  );
};
